import { Link } from 'react-router-dom'
import { House } from 'lucide-react'
import { t, type Lang } from '../lib/i18n'

interface Props {
  lang: Lang
  className?: string
}

// bench-WAY-HOME.CB-E §1.1 — the way back to the Cockpit from Board, Dispatch
// and Staff. Colours come from the caller via `className` because Board's
// header is `bg-card` and Dispatch/Staff are `bg-gray-900` — this component
// has no opinion on either.
export function CockpitMark({ lang, className }: Props) {
  const label = t(lang, 'appTitle')
  return (
    <Link
      to="/cockpit"
      aria-label={label}
      title={label}
      className={`inline-flex items-center justify-center min-h-[44px] min-w-[44px] rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors ${className ?? ''}`}
    >
      <House aria-hidden="true" />
    </Link>
  )
}
